// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3HF62","colBig":"styles_colBig__1vExG","colSmall":"styles_colSmall__1qP5c"};